import { useContext } from "react"
import { MixpanelContext } from "containers/RootRouter/MixpanelContext"

const useMixpanel = () => {
  const mixpanel = useContext(MixpanelContext);
  return mixpanel;
}

export { useMixpanel };